export function attachTooltips($context) {
    const allToolTips = $context.find('.help-tooltip');

    allToolTips
        .on('click', function (event) {
            event.preventDefault();
            $(this).tooltip('show');
        })
        .tooltip({
            trigger: 'manual',
        })
    ;

    $context
        .on('click', function (e) {
            if (0 === $(e.target).closest('.help-tooltip').length) {
                allToolTips.tooltip('hide');
            }
        })
    ;
}
